import React, { useMemo } from "react";
import ChatHistory from "../ChatHistory/ChatHistory";
import { InputField } from "../InputField/InputField";
import ChatHeader from "../ChatHeader/ChatHeader";
import { useConfig } from "./ConfigContext";

export default function InlineWidget({
  resetConversation,
  panel: {
    messages,
    inboundMessage,
    setInboundMessage,
    sendMessage,
    thinking,
    adminConnected,
  },
}) {
  const { config } = useConfig();
  const isIframe = useMemo(() => window.self !== window.top, []);

  return (
    <>
      {config?.useAdvSizes ? (
        <style>
          {`
        @media screen and (max-width:${config?.advSizes?.small.breakPoint}px) {
          .needsDimensions {
          }
        }
        @media screen and (min-width:${config?.advSizes?.small.breakPoint}px) {
          .needsDimensions {
            height: ${config.advSizes?.small.height};
            width: ${config.advSizes?.small.width};
          }
        }
        @media screen and (min-width:${config?.advSizes?.medium.breakPoint}px) {
          .needsDimensions {
            height: ${config.advSizes?.medium.height};
            width: ${config.advSizes?.medium.width};
          }
        }
        @media screen and (min-width:${config?.advSizes?.large.breakPoint}px) {
          .needsDimensions {
            height: ${config.advSizes?.large.height};
            width: ${config.advSizes?.large.width};
          }
        }
        `}
        </style>
      ) : (
        <style>
          {`
          .needsDimensions {
            height: ${config.chatHeight};
            width: ${config.chatWidth};
          }
        `}
        </style>
      )}
      <div
        className="needsDimensions"
        style={{
          borderRadius: isIframe ? "0rem" : "1rem",
          overflow: "hidden",
          margin: "0 auto 1.5rem",
          boxShadow: isIframe ? "none" : "0 5px 10px rgb(0 0 0 / 0.3)",
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <ChatHeader
          toggleChatOpen={() => {}}
          resetConversation={resetConversation}
          adminConnected={adminConnected}
        />
        <ChatHistory messages={messages} thinking={thinking} />
        <InputField
          inboundMessage={inboundMessage}
          setInboundMessage={setInboundMessage}
          onKeyEnter={sendMessage}
        />
      </div>
    </>
  );
}
